import { useNavigate } from 'react-router-dom'
import '../../App.css'
import { AlertBellIcon, BellIcon } from '../../images/Icons'


export function NotificationsButton() {
    const navigate = useNavigate()
    return (
        <div className='iconButton' onClick={() => {
                navigate('/Notifications')
        }}>
            <BellIcon/>
             </div>
    )
}

export function AlertNotificationsButton() {
    const navigate = useNavigate()
    return (
        <div className='iconButton' onClick={() => {
                navigate('/Notifications')
        }}>
                <AlertBellIcon/>
             </div>
    )
}